import { render } from 'preact';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PortalRecentQueriesApp } from '../components/PortalRecentQueriesApp.jsx';
import '../ilan-vitrin/vitrin.css';
import '../styles/portal-recent-queries.css';
import '../styles/portal-compare.css';

const queryClient = new QueryClient();
const root = document.getElementById('pp-portal-recent-queries-root');

if (root) {
  render(
    <QueryClientProvider client={queryClient}>
      <PortalRecentQueriesApp />
    </QueryClientProvider>,
    root,
  );
}
